/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import { bool, func } from 'prop-types';
import {
    Dialog, Typography, Grid,
} from '@material-ui/core';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    mainConainer: {
        padding: '20px 20px 25px 20px',
    },
    infoText: {
        fontSize: '16px',
        lineHeight: '24px',
        fontWeight: 'bold',
        padding: '10px',
        textTransform: 'uppercase',
    },
    closeButton: {
        textAlign: 'right',
        cursor: 'pointer',
        fontSize: '28px',
        position: 'absolute',
        right: '10px',
        top: '0px',
    },
    errorIcon: {
        color: 'red',
        width: '30px',
        height: 'auto',
    },
    errorContainer: {
        margin: '0 auto',
    },
    errorMessage: {
        display: 'flex',
    },
    errorText: {
        padding: '5px',
    },
    topBar: {
        borderBottom: 'solid 1px #000',
    },
}));

const CalendarNotAvailableModal = ({
    isOpen,
    onClose,
}) => {
    const classes = useStyles();

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            data-testid="pna-modal"
        >
            <Grid
                className={classes.topBar}
                container
                direction="row"
                justify="space-between"
            >
                <Grid item className={classes.errorContainer}>
                    <Typography className={classes.infoText}>
                        Calendar
                    </Typography>
                </Grid>
                <Grid item className={classes.closeButton} onClick={onClose}>
                    <span>X</span>
                </Grid>
            </Grid>
            <Grid className={classes.mainConainer}>
                <Grid item className={classes.errorMessage}>
                    <ErrorOutlineIcon className={classes.errorIcon} />
                    <Typography className={classes.errorText}>
                        We are sorry, this product is not available
                    </Typography>
                </Grid>
            </Grid>
        </Dialog>
    );
};

CalendarNotAvailableModal.propTypes = {
    isOpen: bool.isRequired,
    onClose: func.isRequired,
};

export default CalendarNotAvailableModal;
